import { getAllTPA } from 'src/actions/setuphospitaletpaAction';
import { CREATETPA, CREATETPACHARGE, DELETETPA, DELETETPACHARGE, GETALLTPA, GETTPA, GETTPACHARGE, UPDATETPA, UPDATETPACHARGE } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATETPA:
            return {
                ...state,
                tpaSaveStatus: action.payload.success,
            }
        case GETTPA:
                return {
                        ...state,
                        tpaList: action.payload.data,
                        }
        
        case UPDATETPA:
                return {
                        ...state,
                        tpaUpdateStatus: action.payload.success,
                        }   

        case DELETETPA:
                 return {
                     ...state,
                     tpaDeleteStatus: action.payload.success,
                        } 
        case CREATETPACHARGE:
            return {
                ...state,
                tpachargeSaveStatus: action.payload.success,
            }
        case GETTPACHARGE:
                return {
                        ...state,
                        tpachargeList: action.payload.data,
                        }
        case UPDATETPACHARGE:
                return {
                        ...state,
                        tpachargeUpdateStatus: action.payload.success,
                        }   

        case DELETETPACHARGE:
                 return {
                     ...state,
                     tpachargeDeleteStatus: action.payload.success,
                        } 
        case GETALLTPA:
                return {
                        ...state,
                        alltpaList: action.payload.data,
                        }
                        default:
                            return state
                             }
                         }